export default __webpack_public_path__ + "static/media/untick-circle.65e63183.svg";